import * as React from 'react';
import { useNewFilterDialogEnabled } from '@src/utils/filter';
import { FilterDialogContainer } from '@components/filter';
import { FilterDropdown } from '..';
import SummaryBreadcrumb from './SummaryBreadcrumb';

export interface FilterDialogSwitchProps extends React.ComponentProps<typeof SummaryBreadcrumb> {}

const FilterDialogSwitch = (props: FilterDialogSwitchProps) => {
  const newFilterDialogEnabled = useNewFilterDialogEnabled();

  return newFilterDialogEnabled ? (
    <FilterDialogContainer />
  ) : (
    <>
      <FilterDropdown />
      <SummaryBreadcrumb {...props} />
    </>
  );
};

export default React.memo(FilterDialogSwitch);
